import { render, staticRenderFns } from "./show-document-model.vue?vue&type=template&id=b8d03908&scoped=true&"
import script from "./show-document-model.vue?vue&type=script&lang=js&"
export * from "./show-document-model.vue?vue&type=script&lang=js&"
import style0 from "./show-document-model.vue?vue&type=style&index=0&id=b8d03908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d03908",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
